import { GitContributors } from "/home/runner/work/dialtone/dialtone/node_modules/.pnpm/@vuepress+plugin-git@2.0.0-rc.112_typescript@5.8.3_vuepress@2.0.0-rc.24_@vuepress+bundler-vit_xl3ivebhz6rqfiw3iah2wm5nri/node_modules/@vuepress/plugin-git/lib/client/components/GitContributors.js";

export default {
  enhance: ({ app }) => {
    app.component("GitContributors", GitContributors);
  },
};
